import { render, staticRenderFns } from "./event-status-label.vue?vue&type=template&id=06504c9a&scoped=true"
import script from "./event-status-label.vue?vue&type=script&lang=js"
export * from "./event-status-label.vue?vue&type=script&lang=js"
import style0 from "./event-status-label.vue?vue&type=style&index=0&id=06504c9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06504c9a",
  null
  
)

export default component.exports